import { pointerDragThresholdCanvas } from '@/lib/text/text-tool-create'

/** The start/current canvas points every drag gesture (marquee, zoom marquee, text drag) tracks. */
type CanvasDragSpan = {
  startCanvasX: number
  startCanvasY: number
  currentCanvasX: number
  currentCanvasY: number
}

/** Axis-aligned rect spanned by a drag, whichever direction it ran (canvas coordinates). */
export function computeDragSpanRect(drag: CanvasDragSpan): {
  x: number
  y: number
  width: number
  height: number
} {
  const dx = drag.currentCanvasX - drag.startCanvasX
  const dy = drag.currentCanvasY - drag.startCanvasY

  return {
    x: Math.min(drag.startCanvasX, drag.currentCanvasX),
    y: Math.min(drag.startCanvasY, drag.currentCanvasY),
    width: Math.abs(dx),
    height: Math.abs(dy),
  }
}

/** True once the pointer has moved past the click-vs-drag threshold on either axis. */
export function exceedsPointerDragThreshold(drag: CanvasDragSpan, scale: number): boolean {
  const dx = drag.currentCanvasX - drag.startCanvasX
  const dy = drag.currentCanvasY - drag.startCanvasY
  const dragThreshold = pointerDragThresholdCanvas(scale)

  return Math.abs(dx) >= dragThreshold || Math.abs(dy) >= dragThreshold
}

/** The drag's rect once it counts as a drag (see `exceedsPointerDragThreshold`), else null. */
export function computePointerDragRect(
  drag: CanvasDragSpan,
  scale: number
): { x: number; y: number; width: number; height: number } | null {
  if (!exceedsPointerDragThreshold(drag, scale)) return null

  return computeDragSpanRect(drag)
}
